export interface BroadcastNotificationsList {
	per_page: number
	current_page: number
	total_pages: number
	total_items: number
	items: BroadcastNotification[]
}

export type BroadcastNotification = {
	id: number
	text: string
	type: BroadcastNotificationType
	category: BroadcastNotificationCategory
	meta: { [key: string]: string | number }
	read: boolean
	created_at: Date
	updated_at: Date
} & (
	| {
			category: BroadcastNotificationCategory.GENERIC
			type: BroadcastNotificationType.ADMIN_DOCUMENT_ACCEPTED
	  }
	| {
			category: BroadcastNotificationCategory.GENERIC
			type: BroadcastNotificationType.ADMIN_DOCUMENT_REFUSED
	  }
	| {
			category: BroadcastNotificationCategory.INVITATION
			type: BroadcastNotificationType.PATIENT_INVITES_DOCTOR
			meta: {
				patient_id: number
				patient_name: string
				patient_surname: string
				patient_picture: string
				invitation_id: number
			}
	  }
	| {
			category: BroadcastNotificationCategory.MESSAGE
			type: BroadcastNotificationType.NEW_MESSAGE
			meta: {
				patient_id: number
				patient_name: string
				patient_surname: string
				patient_picture: string
				text: string
			}
	  }
	| {
			category: BroadcastNotificationCategory.EXAM_REPORT
			type: BroadcastNotificationType.NEW_REPORTS_ADD_TO_EXAM
			meta: {
				patient_id: number
				patient_name: string
				patient_surname: string
				patient_picture: string
				exam_id: number
				exam_name: string
			}
	  }
)

export enum BroadcastNotificationType {
	PATIENT_INVITES_DOCTOR = "PATIENT_INVITES_DOCTOR",
	NEW_MESSAGE = "NEW_MESSAGE",
	NEW_REPORTS_ADD_TO_EXAM = "NEW_REPORTS_ADD_TO_EXAM",
	ADMIN_DOCUMENT_ACCEPTED = "ADMIN_DOCUMENT_ACCEPTED",
	ADMIN_DOCUMENT_REFUSED = "ADMIN_DOCUMENT_REFUSED"
}

export enum BroadcastNotificationCategory {
	GENERIC = "GENERIC",
	INVITATION = "INVITATION",
	EXAM_REPORT = "EXAM_REPORT",
	MESSAGE = "MESSAGE"
}

export type AppNotificationCategory = "message" | "reminder" | "alert" | "news" | "link" | string
export type AppNotificationType = "success" | "info" | "warning" | "error" | "default" | undefined
export interface AppNotificationAction {
	callback: () => void
	label?: string
}
export interface AppNotification {
	id: number
	category: AppNotificationCategory
	type: AppNotificationType
	title: string
	description: string
	read: boolean
	date: string
	action?: AppNotificationAction
}
